import credentials from '../credentials/credentials.json';
export class Configurations {


    get apiBasePath() {
        return credentials.apiFukyo;
    }

        get apiBasePathRemessa() { //??? ALTERAR
        return credentials.apiRemessa;
    }

    get tokenKey() {
        return credentials.tokenKey;
    }

    get hkWebClient() {
        return credentials.hkWebClient;
    }

    get cileDigitalClient() {
        return credentials.cileDigitalClient;
    }
}